// extracted by mini-css-extract-plugin
export var brand = "_6y-9";
export var compact = "_6y-6";
export var extraSmall = "_6y-7";
export var icon = "_6y-0";
export var large = "_6y-4";
export var light = "_6y-1";
export var medium = "_6y-5";
export var outline = "_6y-b";
export var primaryDark = "_6y-a";
export var primaryLight = "_6y-8";
export var primaryModern = "_6y-c";
export var success = "_6y-2";
export var successSolid = "_6y-3";